<template>
  <div class="auto-campaign-edit-section">
    <h1 class="page-header text-center">new autoconnect: {{autoCampaign ? autoCampaign.header : ''}}</h1>
    <loading-icon v-if="autoCampaignLoading" :loadingIconClasses="'campaign-loading'"></loading-icon>
    <div v-else class="auto-campaign">
      <transition name="fade" @after-enter="afterEnterModal">
        <modal
            v-if="showModal"
            :contentAsHtml="modalConfig.contentAsHtml"
            :isWarningModal="modalConfig.isWarningModal"
            showClose
            :wrapperClasses="modalConfig.wrapperClasses"
            :warningProceedText="modalConfig.warningProceedText"
            @close="closeModal"
            @action="modalConfig.actionFunction"
            @proceed="modalConfig.proceedFunction">
          <h3 slot="header" class="modal-title mt-5 sm:mt-10">{{modalConfig.title}}</h3>

          <div slot="body" :class="modalConfig.bodyClasses">
            <p>{{modalConfig.content}}</p>
            <h3 v-if="modalConfig.creditHighlight">{{modalConfig.creditHighlight}}</h3>
          </div>

          <div
              v-if="modalConfig.actionButton"
              slot="action"
              class="send-mms-campaign button larger modal-click-action"
              @click="modalConfig.actionFunction">
            {{modalConfig.actionButton}}
          </div>
        </modal>
      </transition>

      <transition name="fade">
        <div class="campaign-alerts" v-if="Object.keys(alerts).length && !autoCampaignLoading">
          <transition-group name="slide-down">
            <alert v-for="(alert, key, index) in alerts"
                   :key="key + index"
                   :alert="alert"
                   :alertKey="key"></alert>
          </transition-group>
        </div>
      </transition>

      <settings-edit
          v-if="autoCampaign"
          ref="settings"
          :allowEnable="allowEnable"
          :autoCampaignId="autoCampaignId"
          :autoCampaignFromEdit="autoCampaign"
          :otherErrors="errors"
          @setAutoCampaign="setAutoCampaign">
      </settings-edit>

      <div v-if="autoCampaign" class="medium-9 columns" id="message-wrapper-edit">
        <div v-if="!isBrandFollowUpType" class="data-description">
          pick audience(s) and create messages for that audience.
          you can create multiple audiences (i.e. boca and flowers, boca and edibles).
          for each audience, you can create multiple messages to cycle through
          (i.e. different message every time receiving 'win back' or 'after visit').
          <br />
          <b>if customers belong to multiple audiences the audience with the highest priority will be applied.</b>
        </div>

        <div v-if="!isBrandFollowUpType" class="data-title text-right">
          <span class="add-audience-link" @click.stop="createScope">+ audience</span>
        </div>

        <loading-icon v-if="loadingScope" :loadingIconClasses="'campaign-loading'"></loading-icon>
        <div v-if="scopes.length" class="scope-list">
          <scope-edit
              v-for="(scope, index) in scopes"
              :allowMultiMessages="autoCampaign.allow_multi_messages"
              :audiences="scopes.length"
              :autoCampaign="autoCampaign"
              :autoCampaignId="autoCampaignId"
              :autoCampaignType="autoCampaign.type"
              :autoCampaignLabel="autoCampaign.header"
              :key="scope.id"
              :neverSend="neverSend.includes(scope.id)"
              :previousUrls="autoCampaign.previous_urls"
              :onlyOneScope="scopes.length && scopes.length === 1"
              :sendTime="autoCampaign.send_at_local"
              :scope="scope"
              :scopeIndex="index"
              :scopeId="scope.id"
              :shouldChangePriority="!neverSend.includes(scope.id) && !scope.is_filtered && (allMemberScopes.length > 1 || !!neverSend.length)"
              :totalScopes="scopes.length"
              @loadAllScopes="loadScopes">
          </scope-edit>
        </div>
      </div>
      <div class="send-cancel-section">
        <div class="large-12 columns center-button">
          <input type="submit"
                 name="auto_campaign_done"
                 value="done"
                 class="button larger"
                 id="auto-campaign-done"
                 @click.prevent="showDoneWarning">
        </div>
        <div v-if="autoCampaign && hasAccessToAutoCampaign(userAbilitiesValue, 'CREATE', autoCampaign)" class="large-12 columns">
          <a class="float-right link-delete" name="delete_campaign" @click="showDeleteWarning">delete</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Alert from '../../components/shared/Alert'
  import AxiosMixin from '../../mixins/AxiosMixin'
  import GroupWidget from '../../components/GroupWidget/index'
  import LoadingIcon from '../../components/shared/LoadingIcon'
  import { mapGetters, mapState } from 'vuex'
  import Message from '../../components/Message/index'
  import Modal from '../../components/shared/Modal'
  import ModalMixin from '../../mixins/ModalMixin'
  import ScopeEdit from '../../components/AutoCampaigns/ScopeEdit'
  import SettingsEdit from '../../components/AutoCampaigns/SettingsEdit'
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'

  export default {
    name: 'AutoCampaignEdit',

    components: {
      Alert,
      GroupWidget,
      LoadingIcon,
      Message,
      Modal,
      ScopeEdit,
      SettingsEdit,
    },

    mixins: [AxiosMixin, ModalMixin, UserAbilitiesMixin],

    data() {
      return {
        audioCount: 0,
        autoCampaign: null,
        autoCampaignId: null,
        autoCampaignLoading: true,
        autoCampaignBaseUrl: null,
        emojiCount: 0,
        loadingScope: false,
        messageIds: [],
        mmsCount: 0,
        scopes: [],
        smsContent: null,
      }
    },

    methods: {
      afterAutoCampaignLoad(data, alert) {
        const acData = data ? data.auto_campaign : null
        this.autoCampaign = acData
        this.toggleAlert(alert, alert.errorType, !!acData)

        if(acData?.templates) {
          this.$store.commit('SET_NOTIFICATION_TEMPLATES', acData.templates)
        }

        this.autoCampaignLoading = false
      },

      afterCreateScope(data, alert) {
        const hasSuccess = data ? data.success : false
        hasSuccess && this.loadScopes()
        this.toggleAlert(alert, alert.errorType, hasSuccess)
        this.$refs.settings.toggleEnable(false)
        this.loadingScope = false
      },

      afterDeleteAutoCampaign(data, alert) {
        if (data && data.success) {
          this.exitAutoCampaign(true)
        } else {
          this.toggleAlert(alert, alert.errorType)
          this.closeModal()
          window.scrollTo(0, top)
        }
      },

      afterDeleteError(data, alert) {
        alert.message = `${alert.message}. ${error}`
        this.toggleAlert(alert, alert.errorType)
        this.closeModal()
      },

      configDoneWarning(warningMessage, warningTitle, contentAsHtml) {
        const title = warningTitle ? warningTitle : 'exit autoconnect',
          textOnlyContent = contentAsHtml ? null : warningMessage
        this.modalConfig = {
          actionFunction: this.exitAutoCampaign,
          bodyClasses: 'done-warning',
          content: textOnlyContent,
          isWarningModal: true,
          proceedFunction: this.exitAutoCampaign,
          title: title,
          warningProceedText: 'done',
          wrapperClasses: 'confirm-done'
        }
        if (contentAsHtml) { this.$set(this.modalConfig, 'contentAsHtml', warningMessage) }
        this.showModal = true
        if (!this.allowEnable) { this.$refs.settings.toggleEnable() }
      },

      configExtrasDoneModal(autoconnectOk, extraWarning) {
        const audioCountText = `<strong>${this.audioCount}</strong> message${this.audioCount > 1 ? 's' : ''} used voice text`,
          emojisCountText = `<strong>${this.emojiCount}</strong> message${this.emojiCount > 1 ? 's' : ''} used emoji / special character`,
          mmsCountText = `<strong>${this.mmsCount}</strong> message${this.mmsCount > 1 ? 's' : ''} used mms`,
          headsUpText = "- that's awesome! heads up though -",
          emojiMessage = `- ${this.newEmojiCalculationTypeEnabled ? this.emojiAlertMessage : this.classicEmojiAlertMessage}`,
          mediaTypeText = this.audioCount && this.mmsCount ? 'mms or voice text' : this.audioCount ? 'voice text' : 'mms',
          mediaMessage = `once ${mediaTypeText} is included in a message, a minimum of 2 credits are charged`,
          endTitle = 'used in this autoconnect'
        let messageStart,
          warningMessage,
          message,
          title

        switch (true) {
          case (!!this.emojiCount && !!this.mmsCount && !!this.audioCount):
            messageStart = `${audioCountText}, ${mmsCountText} & ${emojisCountText}`
            message = emojiMessage
            title = `emoji, mms & voice text ${endTitle}`
            break;
          case (!!this.mmsCount && !!this.emojiCount):
            messageStart = `${mmsCountText} & ${emojisCountText}`
            message = emojiMessage
            title = `mms & emoji ${endTitle}`
            break;
          case (!!this.audioCount && !!this.emojiCount):
            messageStart = `${audioCountText} & ${emojisCountText}`
            message = emojiMessage
            title = `voice text & emoji ${endTitle}`
            break;
          case (!!this.audioCount && !!this.mmsCount):
            messageStart = `${audioCountText} & ${mmsCountText}`
            message = `${headsUpText} ${mediaMessage}`
            title = `voice text & mms ${endTitle}`
            break;
          case !!this.emojiCount:
            messageStart = emojisCountText
            message = emojiMessage
            title = `emoji ${endTitle}`
            break;
          case !!this.mmsCount:
            messageStart = mmsCountText
            message = `${headsUpText} ${mediaMessage}`
            title = `mms ${endTitle}`
            break;
          case !!this.audioCount:
            messageStart = audioCountText
            message = `${headsUpText} ${mediaMessage}`
            title = `voice text ${endTitle}`
            break;
        }
        warningMessage = `${messageStart} ${message}`
        warningMessage = autoconnectOk ? warningMessage : `${warningMessage}. <br /><br /> ${extraWarning}`
        this.configDoneWarning(warningMessage, title, true)
      },

      configUserInteractions(itemKey, itemObject) {
        this.$store.dispatch('UPDATE_STATE_OBJECT', { stateKey: 'noUserInteractions', itemKey, itemObject })
      },

      createScope() {
        this.loadingScope = true
        const url = `${this.autoCampaignBaseUrl}/create_scope`,
          methodType = 'post'
        let onExtraParam = { extraClasses: 'error-alert', errorType: 'createScope', message: 'issue adding a new audience' }
        this.axiosMethod({methodType, url, onSuccess: this.afterCreateScope, onError: this.setEndpointError, onExtraParam})
      },

      deleteAutoCampaign() {
        const url = this.autoCampaignBaseUrl,
          methodType = 'delete'
        let onExtraParam = { extraClasses: 'error-alert', errorType: 'deleteAc', message: 'issue deleting the autoconnect' }
        this.axiosMethod({methodType, url, onSuccess: this.afterDeleteAutoCampaign, onError: this.afterDeleteError, onExtraParam})
      },

      exitAutoCampaign(isDelete) {
        window.onbeforeunload = null
        const toBudz = this.autoCampaign.type === 16 && isDelete,
          urlBase = '/auto_campaigns'
        window.location.href = toBudz ? `${urlBase}/budz` : isDelete ? urlBase : `${urlBase}/${this.autoCampaignId}`
      },

      extrasAlert(extra) {
        const isAudio = extra === 'audio'

        let alertMessage
        if (extra === 'emoji'){
          alertMessage = this.newEmojiCalculationTypeEnabled ? this.emojiAlertMessage : this.classicEmojiAlertMessage;
        } else {
          alertMessage = isAudio ? this.mediaMessage('voice text') : this.mediaMessage(extra);
        }

        let extraAlert = {
          extraClasses: isAudio ? `${extra}-alert mms-alert` :`${extra}-alert`,
          message: alertMessage
        }
        this.toggleAlert(extraAlert, extra, this.extrasCount[extra] < 1)
      },

      initAutoCampaign() {
        this.autoCampaignBaseUrl = `/api/v3/auto_campaigns/${this.autoCampaignId}`
        this.$store.dispatch('LOAD_CURRENT_MERCHANT')
        this.loadAutoCampaign()
        this.loadScopes()
        this.$store.dispatch('LOAD_CAMPAIGN_CONFIGURATION')
        this.listenForAutoCampaignExit()
      },

      listenForAutoCampaignExit() {
        window.onbeforeunload = () => {
          if (!this.allowEnable || Object.keys(this.errors).length) {
            this.$refs.settings.toggleEnable()
            const name = this.autoCampaign.name,
              exitMessage = 'Are you sure you want to exit'
            return name ? `${exitMessage} autoconnect ${name}?` : `${exitMessage} the autoconnect?`
          }
        }
      },

      loadAutoCampaign() {
        const url = this.autoCampaignBaseUrl
        let alert = { extraClasses: 'error-alert', errorType: 'loadAc', message: 'issue loading the autoconnect' }
        this.axiosMethod({url, onSuccess: this.afterAutoCampaignLoad, onError: this.setEndpointError, onExtraParam: alert})
      },

      loadScopes() {
        const url = `/api/v3/auto_campaign_scopes/?auto_campaign_id=${this.autoCampaignId}`
        let alert = { extraClasses: 'error-alert', errorType: 'loadScopes', message: 'issue loading audiences' }
        this.axiosMethod({url, onSuccess: this.setScopes, onError: this.setEndpointError, onExtraParam: alert})
      },

      mediaEmojiCount(state, getters) {
        let audio = 0,
          emoji = 0,
          mms = 0
        for (let key in state) {
          if (key.includes('message')){
            this.smsContent = state[`${key}`]?.updatedSmsContent;
            let audiosLength = getters[`${key}/audios`].length,
              mmsLength = getters[`${key}/mmsAsLink`] ? 0 : getters[`${key}/mms`].length
            if (audiosLength > 0) { audio += audiosLength }
            if (state[key].hasEmoji) { emoji += 1 }
            if (mmsLength > 0) { mms += mmsLength }
          }
        }
        return { audio, emoji, mms }
      },

      mediaMessage(mediaType) {
        const start = `you used ${mediaType} in this message - that's awesome! heads up though - once `,
          end = `${mediaType} is included in a message, a minimum of 2 credits are charged`
        return start + end
      },

      setAutoCampaign(autoCampaign) {
        this.autoCampaign = {...autoCampaign}
      },

      setEndpointError(error, alert) {
        const isCreateScope = alert.message.includes('adding')
        alert.message = `${alert.message}. ${error}`
        this.toggleAlert(alert, alert.errorType)
        if (isCreateScope) {
          this.loadingScope = false
        } else {
          this.autoCampaignLoading = false
        }
      },

      setExtrasCountAlert() {
        ['emoji', 'mms', 'audio'].forEach((extra) => {
          let count = this.extrasCount ? this.extrasCount[extra] : 0
          if (this[`${extra}Count`] !== count) {
            this[`${extra}Count`] = count
            this.extrasAlert(extra)
          }
        })
      },

      setScopes(data, alert) {
        const isValidData = Array.isArray(data)
        if (isValidData) { this.scopes = data }
        this.toggleAlert(alert, alert.errorType, isValidData)
      },

      showDeleteWarning() {
        this.modalConfig = {
          actionFunction: this.deleteAutoCampaign,
          bodyClasses: 'delete-warning',
          content: "are you sure you want to delete this auto campaign and all of its history?",
          isWarningModal: true,
          proceedFunction: this.deleteAutoCampaign,
          title: 'delete this autoconnect',
          warningProceedText: 'delete autoconnect',
          wrapperClasses: 'confirm-delete'
        },
        this.showModal = true
      },

      showDoneWarning() {
        if (this.smsContent.trim().length === 0) {
          this.autoCampaign.enabled = false;
          this.$refs.settings.updateSettings(this.autoCampaign);
        }
        const isEnabled = this.autoCampaign.enabled,
          autoconnectOk = isEnabled && this.allowEnable,
          allowEnableMessage = 'please note, your autoconnect is not currently enabled. this autoconnect will not send any messages until it is enabled.',
          withErrorsMessage = 'there are some errors pending in your autoconnect. please fix these errors in order to be able to enable the autoconnect.',
          warningMessage = this.allowEnable ? allowEnableMessage : withErrorsMessage,
          hasExtras = Object.values(this.extrasCount).reduce((sum, key) => sum + key)

        if (hasExtras) {
          this.configExtrasDoneModal(autoconnectOk, warningMessage)
        } else if (isEnabled && this.allowEnable) {
          this.exitAutoCampaign()
        } else {
          this.configDoneWarning(warningMessage)
        }
      },

      toggleAlert(alert, itemKey, shouldRemove) {
        const itemObject = shouldRemove ? {} : alert
        this.$store.dispatch('UPDATE_STATE_OBJECT', { stateKey: 'alerts', itemKey, itemObject})
      },
    },

    created() {
      this.$store.dispatch('LOAD_CURRENT_USER')
      this.autoCampaignId = this.$route.params.id
      this.autoCampaignId && this.initAutoCampaign()
    },

    beforeDestroy() {
      this.$store.commit('RESET_ALERTS')
    },

    computed: {
      allowEnable: function () {
        const hasNoInteractionKeys = this.noUserInteractions ? !Object.keys(this.noUserInteractions).length : false,
          blacklistValid = this.allowBlockBlacklist ? !this.hasBlacklistedWords : true,
          hasNoErrorKeys = this.errors ? !Object.keys(this.errors).length : false
        return hasNoInteractionKeys && hasNoErrorKeys && blacklistValid
      },

      allMemberScopes: function() {
        return this.scopes.filter((scope) => !scope.is_filtered)
      },

      extrasCount: function () {
        const state = this.$store.state,
          getters = this.$store.getters
        return this.mediaEmojiCount(state, getters)
      },

      neverSend: function () {
        const alert = {
          extraClasses: "no-all-member-alert",
          message: "there is no unfiltered audience. this autoconnect may not reach all of your customers"
        },
        unfilteredScopes = this.scopes.filter((scope) => !scope.is_filtered)

        if (!!unfilteredScopes.length) {
          this.toggleAlert(alert, 'neverSend', true)
          const highestPriority = unfilteredScopes[0].priority
          return this.scopes.filter((scope) => scope.priority > highestPriority).map((scope) => scope.id)
        } else {
          if (this.autoCampaign) { this.toggleAlert(alert, 'neverSend') }
          return []
        }
      },

      isBrandFollowUpType() {
        return this.autoCampaign.type === 20
      },

      ...mapGetters([
        'userAbilitiesValue',
        'classicCampaignsEnabled',
        'newEmojiCalculationTypeEnabled',
      ]),

      ...mapState([
        'alerts',
        'allowBlockBlacklist',
        'emojiAlertMessage',
        'classicEmojiAlertMessage',
        'errors',
        'noUserInteractions'
      ]),
    },

    watch: {
      extrasCount: function () {
        this.setExtrasCountAlert()
      }
    }
  }
</script>
